import { Component, OnInit }            from '@angular/core';
import { Router }                       from '@angular/router';
import { UserService }                  from '../../_services/user.service'; 
import { OrgAuthService }               from '../../auth/org/orgauth.service';


import { RecaptchaModule , RecaptchaFormsModule}              from 'ng-recaptcha';
//import { RecaptchaFormsModule }         from 'ng-recaptcha/forms';
//import { IMG_ANI_REFRESH}               from '../../_models/constants';
//import { UsePiwikTracker } from 'Angular2Piwik';
import { first }          from 'rxjs/operators';
import { Subscription } from 'rxjs';

export interface FormModel {
  captcha?: string;
}
declare var $: any;
@Component({
  selector: 'org-register',
  //providers: [UsePiwikTracker],  
  templateUrl: './orgregister.component.html',
  styleUrls: ['./orgregister.component.css']
})

export class OrgRegisterComponent implements OnInit {

    model: any = {};
    formModel: FormModel = {};
    loading:boolean = false;
    success:boolean = false;
    failure:boolean = false;
    doc: any;
    subscription: Subscription | null = null;
    constructor(
        private router: Router,
        private userService: UserService,
        ) {
        //    usePiwikTracker.trackPageView();
         }

    ngOnInit() {
        //this.IMG_ANI_REFRESH = IMG_ANI_REFRESH;
    }

    ngOnDestroy() {
        //$('#addedThis').remove();
        //$('.addthis-smartlayers').remove();  
        try{
            this.subscription?.unsubscribe();  
        }catch(e){

        }        
    }

    register() {//alert('here'+JSON.stringify(this.model))
        this.loading = true;
        this.subscription = this.userService.orgRegisterEmail(this.model)
            .pipe(first())
            .subscribe(
                data => {//alert('Registration is successful');
                    this.model = {};
                    this.success = true;
                    /*$('#addedThis').remove();
                    $('.addthis-smartlayers').remove();
                    var s = document.createElement("script");
                    s.id = "addedThis";
                    s.type = "text/javascript";
                    s.src = "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a14efa6efc2db8a";
                    $("body").append(s);                                */
                },
                error => {
                    //alert("The email id is already registered. Please use a different email id or click on 'Reset Your Password' link to reset your password.")
                    this.failure = true;
                    this.loading = false;                              
                });        
    }
}
